import { useSnapshot } from 'valtio';

import { JobStatus, Variation } from '../types';

type ReadonlyVariations = ReturnType<typeof useSnapshot<Variation[]>>;

export default function getCombinedVariationStatus(
  variations?: ReadonlyVariations,
): JobStatus | undefined {
  if (!variations) return undefined;
  const statusArray = variations.map((v) => v.status);

  if (statusArray.includes('FAILED')) return 'FAILED';
  else if (statusArray.includes('QUEUED')) return 'QUEUED';
  else if (statusArray.includes('GENERATING_BVH')) return 'GENERATING_BVH';
  else if (statusArray.includes('GENERATING_PK')) return 'GENERATING_PK';
  return 'COMPLETED';
}
